export const pushPromptKey = (account: string | number) =>
  `rovero.push-prompt.v1:${account}`;
const sessionPrefix = "rovero.push-prompt-session.v1:";
export function mayShowPushPrompt(account: string | number) {
  try {
    return (
      localStorage.getItem(pushPromptKey(account)) !== "never" &&
      sessionStorage.getItem(sessionPrefix + account) !== "shown"
    );
  } catch {
    return false;
  }
}
export function markPushPromptShown(account: string | number) {
  try {
    sessionStorage.setItem(sessionPrefix + account, "shown");
  } catch {
    /* Storage may be unavailable in a restricted browser. */
  }
}
export function dismissPushPrompt(account: string | number, never: boolean) {
  markPushPromptShown(account);
  if (never)
    try {
      localStorage.setItem(pushPromptKey(account), "never");
    } catch {
      /* Keep the current session dismissed. */
    }
}
export function resetPushPromptSession() {
  try {
    for (const key of Object.keys(sessionStorage))
      if (key.startsWith(sessionPrefix)) sessionStorage.removeItem(key);
  } catch {
    /* Login must not depend on browser storage. */
  }
}
